
import React from 'react';
import SearchEmptyState from './SearchEmptyState';
import SearchResultsList from './SearchResultsList';
import { Story } from '@/utils/storiesData';
import { Content } from '@/types/content';

interface SearchContentProps {
  query: string;
  isSearching: boolean;
  searchResults: {
    stories: Story[];
    videos: Content[];
  };
  onItemClick: (path: string) => void;
  onTagClick: (tag: string) => void;
}

const SearchContent: React.FC<SearchContentProps> = ({
  query,
  isSearching,
  searchResults,
  onItemClick,
  onTagClick
}) => {
  const hasResults = searchResults.stories.length > 0 || searchResults.videos.length > 0;
  const shouldShowEmptyState = query.length === 0 || isSearching || !hasResults;

  return (
    <>
      {shouldShowEmptyState ? (
        <SearchEmptyState query={query} isSearching={isSearching} />
      ) : (
        <SearchResultsList 
          storyResults={searchResults.stories}
          contentResults={searchResults.videos}
          onItemClick={onItemClick}
          onTagClick={onTagClick}
        />
      )}
    </>
  );
};

export default SearchContent;
